const lightboxify = (elementsSelector, lightboxSelector, lightboxImageSelector) => {
    const elements = [...document.querySelectorAll(elementsSelector)];
    const lightbox = document.querySelector(lightboxSelector);
    const lightboxImage = document.querySelector(lightboxImageSelector);

    if (elements.length === 0 || !lightbox || !lightboxImage) return;

    elements.forEach((element) => {
        element.addEventListener('click', () => {
            let url = getImageSource(element);

            if (!url) {
                console.error('No image source found on this lighboxify element ...');
                return;
            }

            setLightboxImage(url);
            showLightbox();
        });
    });

    function setLightboxImage(url) {
        lightboxImage.src = url;
    }

    function showLightbox() {
        lightbox.classList.remove('hidden');
    }
};

function getImageSource(element) {
    if (element.src) return element.src;

    if (element.style.backgroundImage !== '') return element.style.backgroundImage.slice(4, -1).replace(/['"]/g, '');

    return null;
}

export { lightboxify };
